import {StyledProps, React, _, observable, styled, classNames, observer, Fragment } from '@api'
import {Tooltip2} from '@api'

import { BlueprintCardInPopoverRefactorMe } from '@design-board/components'
import { MenuItem, ListItemText, Checkbox, Tooltip, Dialog, DialogTitle } from '@material-ui/core'
import {withStyles} from '@material-ui/core/styles'
import { MenuDivider, Navbar, NavbarGroup, Button, Spinner, ControlGroup, RadioGroup, Radio,FormGroup, Collapse } from '@blueprintjs/core'
import * as css from './ExportView.css'
import {Stores } from '@stores'
import * as pdfCss from './PdfReportBuilderToolbar.css'
import { IExportOption } from '@stores/config'
import {observer as classObserver} from 'mobx-react'

const styles = theme => ({
  modal:        {
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center'
  },
  paper:        {
    display:         'flex',
    justifyContent:  'center',
    width:           theme.spacing() * 80,
    height:          theme.spacing() * 84,
    backgroundColor: theme.palette.background.paper,
    boxShadow:       theme.shadows[5],
    padding:         0,
    borderRadius:    2,
    flexDirection:   'column',
    fontSize:        24,
    outline:         'none'
  },
  title:        {
    height:         80,
    borderBottom:   '1px solid #dedede',
    width:          '100%',
    display:        'flex',
    justifyContent: 'center',
    alignItems:     'center'
  },
  exportView:   {
    maxWidth: 300
  },
  listWrapper:  {
    width:          '100%',
    display:        'flex',
    alignItems:     'center',
    justifyContent: 'center'
  },
  listItem:     {
    height: 56,
    width:  300
  },
  listItemText: {
    width:        '230px',
    whiteSpace:   'nowrap',
    overflow:     'hidden',
    textOverflow: 'ellipsis'
  },
  footer:       {
    height:         80,
    justifyContent: 'flex-end',
    display:        'flex',
    alignItems:     'center',
    marginRight:    24
  },
  checkbox:     {
    '& svg': {
      width:  20,
      height: 20
    }
  },
  primary: {
    '&:hover': {
      backgroundColor: 'rgb(65, 131, 243) !important'
    }
  },
  icon: {
    margin: '2px'
  },
  cancelButton: {
    marginRight: '10px'
  },
 modalTitle: {
   padding:'unset'
 },
 messageDiv: {
   padding:'5px 0',
   fontSize:'15px'
 },
 dialog: {
   padding:'10px !important'
 },
 disabled: {
  pointerEvents: 'none',
  opacity: 0.4
 }
})
const FieldsGrid = styled.div`
display:grid;
grid-template-columns: 1fr 1fr 1fr;


> * {
  min-width: 8em;
}
`


interface MyProps extends StyledProps {
  stores: Partial<Stores>
}

@(withStyles as any)(styles)
@classObserver
export class ExportViewExcel extends React.Component<MyProps> {
  render() {
    const style:any = css, {stores} = this.props
    const {
      strings, export: {onClose, toggleExportOption, modalOpen, exportModalTitle, exportOptions, excelImageExportOptions,
      exportOptionsView, exportProgress, selectedImageSize, onChangeImageSize, isImageExport, onDoExport, includeImageToExport} } = stores
    const {classes} = this.props

    return (
      <Dialog open={modalOpen} className={classNames(css.root, classes.dialog)} >
        <DialogTitle className={classes.modalTitle}>
          <MenuDivider title={exportModalTitle} />
        </DialogTitle>
        <BlueprintCardInPopoverRefactorMe className={classes.dialog}>
          {isImageExport ?
            <RadioOptionGroup className={classes.messageDiv} message={strings.exportImageSizes} onChange={onChangeImageSize} selectedValue={selectedImageSize} groupName={strings.imageSizes} options={exportOptions} inline={true} disabled={exportProgress} />
            :
            <Fragment>
            <FieldsGrid className={style.fields}>
              {
                _.map(exportOptions, list => (
                  <MenuItem onClick={(e) => { toggleExportOption(e, list.value) }} key={list.value} className={style.field}>
                    <Tooltip2 content={list.name}>
                      <ListItemText className={style.fieldText} classes={{ primary: style.fieldName }}>{list.name}</ListItemText>
                    </Tooltip2>
                    <Checkbox
                      className={style.checkbox}
                      checked={!!exportOptionsView[list.value]}
                      disabled={exportProgress}
                    />
                  </MenuItem>
                ))
              }
            </FieldsGrid>
            <Collapse isOpen={includeImageToExport}><RadioOptionGroup onChange={onChangeImageSize} selectedValue={selectedImageSize} groupName={strings.imageSizes} options={excelImageExportOptions} inline={true} disabled={exportProgress} /></Collapse>
          </Fragment>
          }
        </BlueprintCardInPopoverRefactorMe>
        <Navbar>
          <NavbarGroup align={'right'}>
            <Button className={classes.cancelButton} text={strings.cancel} minimal={false} onClick={onClose} />
            <Button className={pdfCss.pdfDownloadButton} minimal={false} text={strings.export} intent='primary'
              rightIcon={exportProgress ? <Spinner className={classNames(css.spinner, pdfCss.spinner)} size={16} /> : 'download'}
              onClick={onDoExport} />
          </NavbarGroup>
        </Navbar>
      </Dialog>
    )
  }
}

export interface IRadioOptionGroupProps {
  inline?: boolean,
  message?: string,
  className?: string,
  options?: Array<IExportOption>,
  selectedValue: any,
  onChange: (e) => any,
  disabled?: boolean,
  groupName: string
}

export const RadioOptionGroup = observer<IRadioOptionGroupProps>(({ message, className, options, inline, selectedValue, onChange, disabled, groupName }) => {
  return <Fragment>
    <div className={className}>{message}</div>
    <fieldset>
      <legend>{groupName}</legend>
      <ControlGroup vertical>
        <FormGroup>
          <RadioGroup inline={inline} disabled={disabled}
            onChange={e => onChange(e)}
            selectedValue={selectedValue}
          >
            {_.map(options, ({ value, name }) => (<Radio key={value} label={name} value={value} />))}
          </RadioGroup>
        </FormGroup>
      </ControlGroup>
    </fieldset>
  </Fragment>
})



// WEBPACK FOOTER //
// ./src/modules/siteHeader/components/ExportViewExcel.tsx